import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Container, Grid, Card, CardContent,
    Divider, Button, CircularProgress, Snackbar, Alert,
    Select, MenuItem, Checkbox,
    FormControlLabel
} from "@mui/material";
import { Helmet } from 'react-helmet-async';
import { authenticationService } from "src/services";
import { put, post, get } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';

const EditPackage = (props) => {
    const { showSnackbar } = useSnackbar();
    const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();

    const appIntegrations = localStorage.getItem('appIntegrations');
    const appIntegrationsList = appIntegrations ? JSON.parse(appIntegrations) : [];

    const defaultFormValues = {
        id: '',
        packageId: '',
        ncfCharges: '',
        category: "", // Keep this if your API expects it, or remove it
        broadcasterId: "",
        broadcasterName: "",
        planName: '',
        planAmount: '',
        biMonthlyAmount: '',
        quarterlyAmount: '',
        halfYearlyAmount: '',
        annualAmount: '',
        description: '',
        details: '',
        packageType: 'PACKAGE',
        
        subPackageIds: [],
        subPackageNames: [],
        status: '',
        vendorId: vendorId,
        franchiseId: franchiseId,
        appType: '',
        planId: '',
        defaultPackage: false,
        isRefundable: false,
        isTaxIncluded: true,
    };

    const [formValues, setFormValues] = useState(defaultFormValues);
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [errors, setErrors] = useState({});
    const [appSubscriptionPlans, setAppSubscriptionPlans] = useState([])
    const [broadcasters, setBroadcasters] = useState([]);
    const [packages, setPackages] = useState([]);

    const handleChange = (e) => {
        const { id, value } = e.target;

        setFormValues((prev) => ({
            ...prev,
            [id]: value,
        }));

        if (errors[id]) {
            setErrors((prev) => ({ ...prev, [id]: '' }));
        }
    };

    /* const handleCheckboxChange = (e) => {
        setFormValues((prev) => ({
            ...prev,
            defaultPackage: e.target.checked
        }));
    }; */

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setFormValues((prev) => ({
            ...prev,
            [name]: checked
        }));
    };

    const fetchBroadcasters = async () => {
        try {
            const response = await get(
                `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_BROADCASTER}/${vendorId}`
            );

            setBroadcasters(response || []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchPackages = async () => {
  try {
    const response = await get(
      `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}/vendor/${vendorId}/getAllPackagesByVendor`
    );

    const responseData = response?.data || [];

    const filteredPackages = responseData.filter(
      (pkg) => pkg.packageType !== 'A-LA-CARTE' && pkg.packageType !== 'BOUQUET'
    );

    setPackages(filteredPackages);
  } catch (error) {
    console.error("Error fetching packages:", error);
  }
};

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'planName',
            'planAmount',
            'status'
        ];

        requiredFields.forEach((field) => {
            if (!formValues[field] || formValues[field].toString().trim() === '') {
                newErrors[field] = 'This field is required';
            }
        });

        if (formValues.appType && !formValues.planId) {
            newErrors.planId = 'Plan selection required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleStatusChange = (e) => {
        setFormValues({ ...formValues, status: e.target.value });
    };

    const handleClose = () => {
        props.handleClose();
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const onUpdate = async () => {
        if (!validateForm()) {
            showSnackbar('Please fill all required fields', 'error');
            return;
        }
        const payload = {
            ...formValues,
            ncfCharges: Number(formValues.ncfCharges || 0),
            planAmount: Number(formValues.planAmount || 0),
            biMonthlyAmount: Number(formValues.biMonthlyAmount || 0),
            quarterlyAmount: Number(formValues.quarterlyAmount || 0),
            halfYearlyAmount: Number(formValues.halfYearlyAmount || 0),
            annualAmount: Number(formValues.annualAmount || 0),
        };
        setLoading(true);
        const response = await updatePackage(payload);
        setLoading(false);
        
        if (response?.statusCode == 200) {
            showSnackbar(response?.message, 'success')
            props.handleRefresh();
            props.handleClose();
        }
    };

    async function updatePackage(data) {
        try {
            const response = await put(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}`, data);
            const responseData = response;
            return responseData;
        } catch (error) {
            
            if (error?.response?.data != undefined && error?.response?.data != "") {
                showSnackbar(error.response.data, 'error')
            } else {
                showSnackbar('Update Package Failed', 'error')
            }
            return null;
        }
    }

    useEffect(() => {
        fetchBroadcasters()
        fetchPackages();
    }, [])

    useEffect(() => {
        if (props.packageData) {
            setFormValues({
                id: props.packageData.id || '',
                ncfCharges: props.packageData.ncfCharges || '',
                packageId: props.packageData.packageId || '',
                planName: props.packageData.planName || '',
                category: props.packageData.category || "",
                broadcasterId: props.packageData.broadcasterId || "",
                broadcasterName: props.packageData.broadcasterName || "",
                defaultPackage: props.packageData.defaultPackage || false,
                isRefundable: props.packageData.isRefundable || false,
                isTaxIncluded: props.packageData.isTaxIncluded ?? true,
                planAmount: props.packageData.planAmount || '',
                biMonthlyAmount: props.packageData.biMonthlyAmount || '',
                quarterlyAmount: props.packageData.quarterlyAmount || '',
                halfYearlyAmount: props.packageData.halfYearlyAmount || '',
                annualAmount: props.packageData.annualAmount || '',
                description: props.packageData.description || '',
                details: props.packageData.details || '',
                packageType: props.packageData.packageType,
                packageCategory: props.packageData.packageCategory || '',
                subPackageIds: props.packageData.subPackageIds || [],
                subPackageNames: props.packageData.subPackageNames || [],
                status: props.packageData.status || '',
                appType: props.packageData.appType || '',
                planId: props.packageData.planId || ''
            });
        } else {
            setFormValues(defaultFormValues);
        }
    }, [props.packageData]);

    const handlePackageTypeChange = (e) => {
    const packageType = e.target.value;

    setFormValues((prev) => ({
        ...prev,
        packageType,
        // Clear selected packages if type is changed from BOUQUET
        subPackageIds: packageType === 'BOUQUET' ? prev.subPackageIds : [],
    }));
};

    const handleAppTypeChange = (e) => {
        const appType = e.target.value;
        setAppSubscriptionPlans([]);
        setFormValues((prev) => ({
            ...prev,
            appType: appType,
            planId: ""
        }));

        appPlansList(appType);
    };

    const appPlansList = async (appType) => {
        try {
            setLoading(true);

            if (appType === "WATCHO") {
                const response = await post(`${process.env.REACT_APP_BASE_API_URL}/api/watcho/vendor/${vendorId}/plans`);

                const plans = response?.Result || [];

                const mappedPlans = plans.map((plan) => ({
                    planId: 12345678,
                    planName: 'Test Package',
                    planPrice: 20
                }));

                setAppSubscriptionPlans(mappedPlans);
            }
        } catch (err) {
            console.log(err);
            showSnackbar("Failed to load plans", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Edit Package</title>
            </Helmet>
            <Container maxWidth="lg" sx={{ paddingBottom: '25px' }}>
                <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
                    <Grid item xs={12}>
                        <Card>
                            <Divider />
                            <CardContent>
                                <Box sx={{ paddingBottom: "20px" }}>
                                    <Box sx={{
                                        paddingBottom: "20px",
                                        boxShadow: 0,
                                        p: 1,
                                        m: 1,
                                        borderRadius: 2,
                                        textAlign: 'center'
                                    }}>
                                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    id="planName"
                                                    value={formValues.planName}
                                                    label="Plan Name"
                                                    fullWidth
                                                    onChange={handleChange}
                                                    error={!!errors.planName}
                                                    helperText={errors.planName}
                                                />
                                            </Grid>

                                           {/*  <Grid item xs={6}>
    <Select
        id="packageType"
        value={formValues.packageType}
        onChange={handlePackageTypeChange}
        displayEmpty
        fullWidth
        renderValue={(selected) =>
            selected ? selected : 'Select Package Type'
        }
    >
        <MenuItem value="">Package Type</MenuItem>
        <MenuItem value="BASIC">BASIC</MenuItem>
        <MenuItem value="PACKAGE">PACKAGE</MenuItem>
        <MenuItem value="BOUQUET">BOUQUET</MenuItem>
    </Select>
</Grid> */}

                                            
{ formValues.packageType === "BOUQUET" && <Grid item xs={6}>
  <Select
    multiple
    fullWidth
    displayEmpty
    value={formValues.subPackageIds}
    onChange={(e) => {
  const selectedIds = e.target.value;

  const selectedNames = packages
    .filter((pkg) => selectedIds.includes(pkg.id))
    .map((pkg) => pkg.planName);

  setFormValues((prev) => ({
    ...prev,
    subPackageIds: selectedIds,
    subPackageNames: selectedNames,
  }));
}}
    renderValue={(selected) => {
      if (!selected || selected.length === 0) {
        return "Select Packages";
      }

      return packages
        .filter((pkg) => selected.includes(pkg.id))
        .map((pkg) => pkg.planName)
        .join(", ");
    }}
  >
    <MenuItem value="" disabled>
      Select Packages
    </MenuItem>

    {packages.map((pkg) => (
      <MenuItem key={pkg.id} value={pkg.id}>
        {pkg.planName}
      </MenuItem>
    ))}
  </Select>
</Grid>}

                                            {/* <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    id="planAmount"
                                                    value={formValues.planAmount}
                                                    label="MonthlyPlan"
                                                    fullWidth
                                                    onChange={handleChange}
                                                    error={!!errors.planAmount}
                                                    helperText={errors.planAmount}
                                                />
                                            </Grid> */}

                                            <Grid item xs={6}>
    <TextField
        required
        id="planAmount"
        value={formValues.planAmount}
        label="1 Month Plan"
        type="number"
        fullWidth
        onChange={handleChange}
        error={!!errors.planAmount}
        helperText={errors.planAmount}
        inputProps={{ min: 0 }}
    />
</Grid>

<Grid item xs={6}>
    <TextField
        id="biMonthlyAmount"
        value={formValues.biMonthlyAmount}
        label="2 Months Plan"
        type="number"
        fullWidth
        onChange={handleChange}
        inputProps={{ min: 0 }}
    />
</Grid>

<Grid item xs={6}>
    <TextField
        id="quarterlyAmount"
        value={formValues.quarterlyAmount}
        label="3 Months Plan"
        type="number"
        fullWidth
        onChange={handleChange}
        inputProps={{ min: 0 }}
    />
</Grid>

<Grid item xs={6}>
    <TextField
        id="halfYearlyAmount"
        value={formValues.halfYearlyAmount}
        label="6 Months Plan"
        type="number"
        fullWidth
        onChange={handleChange}
        inputProps={{ min: 0 }}
    />
</Grid>

<Grid item xs={6}>
    <TextField
        id="annualAmount"
        value={formValues.annualAmount}
        label="12 Months Plan"
        type="number"
        fullWidth
        onChange={handleChange}
        inputProps={{ min: 0 }}
    />
</Grid>

                                            <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    id="ncfCharges"
                                                    label="NCF Charges"
                                                    type="number"
                                                    fullWidth
                                                    value={formValues.ncfCharges}
                                                    onChange={handleChange}
                                                    inputProps={{ min: 0 }}
                                                />
                                            </Grid>

                                            {appIntegrationsList.length > 0 && (
                                                <Grid item xs={6}>
                                                    <Select
                                                        id="appType"
                                                        value={formValues.appType}
                                                        onChange={handleAppTypeChange}
                                                        displayEmpty
                                                        fullWidth
                                                        renderValue={(selected) =>
                                                            selected ? selected : "Select App Type"
                                                        }
                                                        disabled={appIntegrationsList.length === 0}
                                                    >
                                                        <MenuItem value="">App Type</MenuItem>

                                                        {appIntegrationsList.map((app) => (
                                                            <MenuItem key={app} value={app}>
                                                                {app}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                            )}
                                            {appIntegrationsList.length > 0 && (
                                                <Grid item xs={6}>
                                                    <Select
                                                        id="planId"
                                                        value={formValues.planId}
                                                        onChange={(e) =>
                                                            setFormValues({ ...formValues, planId: e.target.value })
                                                        }
                                                        displayEmpty
                                                        fullWidth
                                                        error={!!errors.planId}
                                                        disabled={!formValues.appType || appIntegrationsList.length === 0}
                                                        renderValue={(selected) =>
                                                            selected
                                                                ? appSubscriptionPlans.find(p => p.planId === selected)?.planName
                                                                : "Select Subscription Plan"
                                                        }
                                                    >
                                                        <MenuItem value="">Select Subscription Plan</MenuItem>

                                                        {appSubscriptionPlans.map((plan) => (
                                                            <MenuItem key={plan.planId} value={plan.planId}>
                                                                {plan.planName} - ₹{plan.planPrice}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                            )}

                                            {/* Category dropdown removed */}

                                            <Grid item xs={6}>
                                                <Select
                                                    fullWidth
                                                    value={formValues.broadcasterId}
                                                    displayEmpty
                                                    onChange={(e) => {
                                                        const selected = broadcasters.find(
                                                            (item) => item.id === e.target.value
                                                        );

                                                        setFormValues({
                                                            ...formValues,
                                                            broadcasterId: selected?.id || "",
                                                            broadcasterName: selected?.name || "",
                                                        });
                                                    }}
                                                    renderValue={(selected) =>
                                                        selected
                                                            ? broadcasters.find((b) => b.id === selected)?.name
                                                            : "Select Broadcaster"
                                                    }
                                                >
                                                    <MenuItem value="">Select Broadcaster</MenuItem>

                                                    {broadcasters.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <TextField
                                                    required
                                                    id="description"
                                                    value={formValues.description}
                                                    label="Description"
                                                    fullWidth
                                                    onChange={handleChange}
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Select
                                                    id="status"
                                                    value={formValues.status}
                                                    onChange={handleStatusChange}
                                                    displayEmpty
                                                    fullWidth
                                                    renderValue={(selected) => (selected ? selected : 'Select Status')}
                                                >
                                                    <MenuItem value="">Status</MenuItem>
                                                    <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                                                    <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                                                </Select>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="defaultPackage"
                                                            checked={formValues.defaultPackage}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label="Default Package"
                                                />

                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isRefundable"
                                                            checked={formValues.isRefundable}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label="Refundable"
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isTaxIncluded"
                                                            checked={formValues.isTaxIncluded}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    }
                                                    label="Tax Included"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ float: "right", paddingBottom: "20px", paddingTop: "15px" }}>
                                        <Button sx={{ marginInline: "8px" }} onClick={handleClose} variant="contained" disabled={loading}>Cancel</Button>
                                        <Button onClick={onUpdate} variant="contained" disabled={loading}>
                                            {loading ? <CircularProgress size={24} /> : 'Update'}
                                        </Button>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>

            <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default EditPackage;